var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('Banner',{on:{"signupModalToggle":function($event){return _vm.$emit('signupModalToggle')}}}),_c('CryptoCarousel'),_c('Markets'),_c('Advantages'),_c('Support'),_c('Comments'),_c('BlogPosts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }